<!-- Translated: skip -->
<template>
  <Modal @close="closeModalLocal" :wide="true">
    <div slot="header">
      <div class="modal-header">
        <div class="" v-if="unit">
        </div>
      </div>
    </div>
    <div class="modal-content" v-if="unit">

      <div class="h1">
        <h1>{{(unit.display_name || unit.description_title)}}</h1>
      </div>

      <div class="special-periods">

        <div class="heading">
          Specialveckor
        </div>

        <table>
          <tr class="title-row">
            <th>
              <b>Helg</b>
            </th>
            <th>
              Datum
            </th>
            <th>
              Pris
            </th>
          </tr>
          <tr v-for="(price, index) in unit.prices_special">
            <td>
              <b v-html="price.title"></b>
            </td>
            <td v-html="price.days">
            </td>
            <td>
              <span :class="{price: true, selected: (cartAccomodationObject && cartAccomodationObject.period && (cartAccomodationObject.unitLid == unit.unit_lid && cartAccomodationObject.poolLid == unit.pool_lid) && cartAccomodationObject.period.period == price.period.period && cartAccomodationObject.period.week == price.period.week)}" v-if="price.period.free" @click="chooseAccomodation({pool_lid: unit.pool_lid, unit_lid: unit.unit_lid, period: price.period, week: price.period.week, name: (unit.display_name || unit.description_title), capacity: unit.capacity, price: price.period.price})">
                {{price.period.price | currency}}
              </span>
              <span class="taken" v-if="!price.period.free">
                uthyrd
              </span>
            </td>
          </tr>
        </table>

      </div>

      <div class="normal-periods">

        <div class="heading">
          PRISÖVERSIKT
        </div>

        <table>
          <tr class="title-row">
            <th>&nbsp;</th>
            <th class="period-super-title" v-for="(meta, index) in meta_super_titles" :colspan="meta_periods.length / meta_super_titles.length">
              {{meta}}
            </th>
          </tr>
          <tr class="title-row">
            <th class="week-indicator">
              <b>Vecka</b>
            </th>
            <th class="week-day-title" v-for="period in meta_periods">
              {{period.days}}
            </th>
          </tr>
          <tr v-for="(week, index) in unit.prices" v-if="index >= meta_weeks[0] && index <= meta_weeks[1]">
            <td class="week-indicator" style="position:relative;">
              <b>v.{{week.week}}</b>
              <popper trigger="click" :options="{placement: 'right'}">
                <div class="popper">
                  <div v-html="showDates(week.periods)"></div>
                </div>
                <span slot="reference">
                  Datum
                </span>
              </popper>
            </td>
            <td v-for="period in week.periods">
              <span :class="{price: true, selected: (cartAccomodationObject && cartAccomodationObject.period && (cartAccomodationObject.unitLid == unit.unit_lid && cartAccomodationObject.poolLid == unit.pool_lid) && cartAccomodationObject.period.period == period.period && cartAccomodationObject.period.week == period.week)}" v-if="period && period.free" @click="chooseAccomodation({pool_lid: unit.pool_lid, unit_lid: unit.unit_lid, period: period, week: week.week, name: (unit.display_name || unit.description_title), capacity: unit.capacity, price: period.price})">
                {{period.price | currency}}
              </span>
              <span class="taken" v-if="period && !period.free">
                uthyrd
              </span>
            </td>
          </tr>
        </table>

      </div>

      <!--<button @click="openModal(['UnitInfoModal', {unit}])">Boendeinformation</button>-->

      <div style="clear:both;margin-top:15px;"></div>
      <p style="text-align:center;" v-if="!loaded">Tillgängligheten uppdaterades senast {{meta_updated | fromNow}}... De laddas nu om, var god vänta...</p>

    </div>
    <pre v-if="false">{{ unit }}</pre>
  </Modal>
</template>

<script>
import { mapMutations, mapGetters } from 'vuex';
import Modal from '@/components/components/Modal';
import API from '@/classes/API';
import moment from 'moment';

import Popper from 'vue-popperjs';
import 'vue-popperjs/dist/css/vue-popper.css';

export default {
  props: {
    params: {},
  },
  components: {
    Modal,
    popper: Popper,
  },
  data() {
    return {
      unit: null,
      meta_periods: null,
      meta_special: null,
      meta_weeks: null,
      meta_super_titles: null,
      meta_updated: null,
      loaded: false,
      firstPrice: {},
      cartAccomodationObject: {},
    };
  },
  mounted() {
    this.loadPrices('null');
    this.loaded = true;
    // this.loadPrices('refresh');
  },
  computed: {
    ...mapGetters([
      'confirmedAccomodations',
      'cart',
    ]),
  },
  methods: {
    async loadPrices(type) {
      let url = `/units/${this.params.pool_lid}/${this.params.unit_lid}/prices`;

      if (type === 'refresh') {
        url = `${url}/refresh`;
      } else {
        const urlInfo = `/units/${this.params.pool_lid}/${this.params.unit_lid}/info`;
        const { data } = await API.get(urlInfo);
        this.unit = data;
      }
      const { data } = await API.get(url);

      this.unit = data.accomodations;
      this.meta_periods = data.meta_periods;
      this.meta_special = data.meta_special;
      this.meta_weeks = data.meta_weeks;
      this.meta_super_titles = data.meta_super_titles;
      this.meta_updated = data.meta_updated;
      const firstKey = Object.keys(this.unit.prices)[10];
      this.firstPrice = this.unit.prices[firstKey];

      if (this.$store.state.tempCartAccomodation && this.$store.state.tempCartAccomodation.type) {
        this.cartAccomodationObject = this.$store.state.tempCartAccomodation;
      } else {
        const currentAccomodationIndex = this.cart.currentAccomodationIndex;
        this.cartAccomodationObject = this.cart.accomodations[currentAccomodationIndex];
      }

      if (type === 'refresh') {
        this.loaded = true;
      }
    },
    closeModalLocal() {
      if (this.$route.query.ref) {
        this.$router.push({ path: `/${this.$route.query.flow}` });
      }
      this.closeModal();
    },
    ...mapMutations([
      'closeModal',
      'closeAllModals',
      'openModal',
      'pickAccomodation',
    ]),
    didChooseAccomodation(payload) {
      const p = payload;
      p.unit = this.unit;
      p.unit_code = this.unit.unit_code || this.unit.name;
      p.description_title = this.unit.description_title;
      p.site = this.unit.facility_id;
      this.pickAccomodation(p);
      this.closeAllModals();
      this.$store.state.tempCartAccomodation = {};

      const no = this.$store.state.cart.accomodations.length - 1;
      this.$router.push({ name: 'confirm-accomodation', query: { d: new Date().getTime(), no } });
    },
    chooseAccomodation(payload) {
      this.didChooseAccomodation(payload);
    },
    showDates(periods) {
      let lines = [];
      lines = [];
      this.meta_periods.forEach((period) => {
        const arrival = moment(periods[period.period_dbid].date_arrival).format('D/M');
        const departure = moment(periods[period.period_dbid].date_departure).format('D/M');
        lines.push(`<b>${period.days}:</b> ${arrival} - ${departure}`);
      });

      return lines.join('<br>');
    },
  },
};
</script>

<style scoped lang="stylus">
@import '~@/global.styl'

.modal-content
  position relative

.h1
  text-align center
  position absolute
  top -74px
  width 100%
  left: 0;
  h1
    united-heavy();
    font-size: 23px;
    text-align: center;
    color: #1c1c1c;
    margin 0 auto
    display inline-block
    background-color: #ffffff;
    border-radius: 5px 5px 0 0;
    padding 17px 28px

.special-periods
  float left
  width 35%
  margin-right 5%

.normal-periods
    float:left
    width:55%
    margin-right 5%

table
  max-width 100%
  tr:nth-child(even)
    background-color #f9f9f9
  td,
  th
    padding 8px 12px
    text-align center
    white-space nowrap
    width 16%

    .price
      border-radius: 4px;
      background-color: greenish-light
      font-size: 13px;
      font-weight: bold;
      color: greenish;
      padding 4px 15px
      display inline-block
      text-align: center;
      cursor pointer
      transition-bt()
      min-width: 77px
      &:hover
        background-color: greenish
        color: greenish-light
    .selected
      background-color gold
      color white
      &:hover
        background-color: greenish
        color: greenish-light
    .taken
      border-radius: 2px;
      background-color: timeslot-taken;
      font-size: 10px;
      font-weight: bold;
      text-align: center;
      color: #ffffff;
      padding 4px 15px
      display inline-block
      text-transform uppercase

.week-indicator
  b
    font-weight bold
    display inline-block
    width 30px
    text-align right
  span
    font-size: 11px;
    font-weight: 300;
    color: #005580;
    text-decoration underline
    cursor pointer
th.week-indicator
  b
    text-transform uppercase

th.period-super-title
  uppercase()

.week-day-title
  font-weight normal

.heading
  united-heavy()
  font-size: 20px;
  color: white;
  border-radius: 3px;
  background-color: var(--booking-color-primary);
  padding: 11px 17px 7px;

.special-periods
  .heading
    background-color deep-sea-blue
    text-transform uppercase
  th, td
    text-align left

.popper
  border-radius 2px
  background-color #262626
  font-family Interstate
  font-size 12px
  font-weight 300
  color #ffffff
  padding 12px
  box-shadow none
  border 0
  text-align left
</style>



// WEBPACK FOOTER //
// UnitPriceModal.vue?5980bc4c